import React from "react";

const DownArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-chevron-down -ml-0.5"
    >
      <path d="m6 9 6 6 6-6"></path>
    </svg>
  );
};

export default DownArrowIcon;
